module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogcmdiYSgyMTQsIDIzNSwgMjM2LCAwLjQpOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzgiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDgiIGNsYXNzPSJjbHMtMSIgd2lkdGg9IjUwIiBoZWlnaHQ9IjUwIiByeD0iMTEiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/wl-white-off.svg
// module id = 6Nn4
// module chunks = 1